module.exports = __webpack_public_path__ + "components/flag/static/square/in-7ff299bf914c980b81cf2bdac954f00c.svg";